import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from './App';

export default function FrontpageFooter() {
  const navigate = useNavigate();
  const { 
    setIsDepositModalOpen, 
    setIsWithdrawModalOpen,
    setIsRedeemModalOpen,
    setIsAuthModalOpen, 
    setAuthModalView, 
    user 
  } = useContext(UserContext);

  const go = (path) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const linkStyle = { 
    color: '#9ca3af', 
    fontSize: '13px', 
    textDecoration: 'none', 
    fontWeight: 700, 
    transition: 'all 0.2s',
    cursor: 'pointer',
    background: 'transparent',
    border: 'none',
    padding: 0,
    textAlign: 'left',
    fontFamily: 'inherit'
  };

  const headerStyle = { 
    color: '#ffb703', 
    fontSize: '14px', 
    fontWeight: 900, 
    marginBottom: '8px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  };

  return (
    <footer className="rc-footer" style={{ 
      background: '#16191f',
      padding: '60px 0 0 0',
      marginTop: '80px',
      fontFamily: '"Montserrat", sans-serif',
      borderTop: '1px solid #1a1c22'
    }}>
      <div style={{
        maxWidth: '1200px', margin: '0 auto', padding: '0 24px',
        display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', gap: '48px'
      }}>
        {/* Branding & Info */}
        <div style={{ maxWidth: '600px' }}>
          <div style={{ fontSize: '32px', fontWeight: 900, color: '#fff', textTransform: 'uppercase', letterSpacing: '-1px', marginBottom: '16px' }}>
            Rusty<span style={{ color: '#ffb703' }}>Coin</span>
          </div>
          <p style={{ fontSize: '13px', color: '#6b7280', lineHeight: 1.7, marginBottom: '28px', fontWeight: 600 }}>
            RustyCoin is the premier destination for Rust skins gambling. We provide a secure, provably fair platform for case opening, battles, and classic casino games.
          </p>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#111318', padding: '10px 16px', borderRadius: '4px', border: '1px solid #1a1c22' }}>
              <img src="/coinimg.png" alt="Certified" style={{ width: '18px', height: '18px' }} />
              <span style={{ fontSize: '12px', color: '#fff', fontWeight: 800 }}>Certified Operator</span>
            </div>
          </div>
        </div>

        {/* Links Grid */}
        <div style={{ width: '100%', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '24px', textAlign: 'center' }}>
          {/* Column 1: Games */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', alignItems: 'center' }}>
            <div style={headerStyle}>Games</div>
            {[
              { name: 'Case Battles', path: '/case-battles' },
              { name: 'Case Opening', path: '/cases' },
              { name: 'Bust', path: '/bust' },
              { name: 'Coinflip', path: '/coinflip' },
              { name: 'Jackpot', path: '/jackpot' }
            ].map(g => (
              <button key={g.name} onClick={() => go(g.path)} style={{...linkStyle, textAlign: 'center'}}>{g.name}</button>
            ))}
          </div>

          {/* Column 2: Rewards */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', alignItems: 'center' }}>
            <div style={headerStyle}>Rewards</div>
            <button onClick={() => go('/dashboard?tab=rewards')} style={{...linkStyle, textAlign: 'center'}}>VIP Benefits</button>

            <button onClick={() => go('/dashboard?tab=rewards')} style={{...linkStyle, textAlign: 'center'}}>Daily Race</button>
          </div>

          {/* Column 3: Info */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', alignItems: 'center' }}>
            <div style={headerStyle}>Info</div>
            <button onClick={() => go('/fairness?tab=fairness')} style={{...linkStyle, textAlign: 'center'}}>Fairness</button>
            <button onClick={() => go('/fairness?tab=tos')} style={{...linkStyle, textAlign: 'center'}}>Terms of Service</button>
            <button onClick={() => go('/fairness?tab=privacy')} style={{...linkStyle, textAlign: 'center'}}>Privacy Policy</button>
            <button onClick={() => go('/fairness?tab=aml')} style={{...linkStyle, textAlign: 'center'}}>AML Policy</button>
            <button onClick={() => go('/fairness?tab=faq')} style={{...linkStyle, textAlign: 'center'}}>FAQ</button>
          </div>

          {/* Column 4: Cashier */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', alignItems: 'center' }}>
            <div style={headerStyle}>Cashier</div>
            <button onClick={() => user ? setIsDepositModalOpen(true) : setIsAuthModalOpen(true)} style={{...linkStyle, textAlign: 'center'}}>Deposit</button>
            <button onClick={() => user ? setIsWithdrawModalOpen(true) : setIsAuthModalOpen(true)} style={{...linkStyle, textAlign: 'center'}}>Withdraw</button>
            <button onClick={() => setIsRedeemModalOpen?.(true)} style={{...linkStyle, textAlign: 'center'}}>Redeem Code</button>
          </div>

          {/* Column 5: Socials */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', alignItems: 'center' }}>
            <div style={headerStyle}>Socials</div>
            <a href="https://discord.gg/7dayErEGt7" target="_blank" rel="noreferrer" style={{...linkStyle, textAlign: 'center'}}>Discord</a>
            <a href="https://kick.com/rustycoincom" target="_blank" rel="noreferrer" style={{...linkStyle, textAlign: 'center'}}>Kick</a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ 
        width: '100%', 
        background: '#ffb703', 
        padding: '16px 0', 
        marginTop: '60px',
        textAlign: 'center',
        position: 'relative',
        zIndex: 2
      }}>
        <div style={{ color: '#000', fontSize: '13px', fontWeight: 900 }}>
          © 2026 RustyCoin. All rights reserved.
        </div>
      </div>
    </footer>
  );
}

